import { render, staticRenderFns } from "./GoodsPurchase.vue?vue&type=template&id=3e94588e&scoped=true"
import script from "./GoodsPurchase.vue?vue&type=script&lang=js"
export * from "./GoodsPurchase.vue?vue&type=script&lang=js"
import style0 from "./GoodsPurchase.vue?vue&type=style&index=0&id=3e94588e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94588e",
  null
  
)

export default component.exports